import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { LoginComponent } from './features/login/login.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { zohoGuard } from './core/guards/zoho.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { LinkZohoComponent } from './features/link-zoho/link-zoho.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'link-zoho', component: LinkZohoComponent },
      { path: 'inbox', canActivate: [zohoGuard], loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'contacts', canActivate: [zohoGuard, permissionGuard('contacts.view')], loadChildren: () => import('./features/contacts/contacts.module').then(m => m.ContactsModule) },
      { path: 'quick-replies', canActivate: [zohoGuard, permissionGuard('quick_replies.view')], loadChildren: () => import('./features/quick-replies/quick-replies.module').then(m => m.QuickRepliesModule) },
      { path: 'volanteos', canActivate: [zohoGuard, permissionGuard('volanteos.view')], loadChildren: () => import('./features/volanteos/volanteos.module').then(m => m.VolanteosModule) },
      { path: 'settings', canActivate: [zohoGuard], loadChildren: () => import('./features/settings/settings.module').then(m => m.SettingsModule) },
      // Mi perfil: personal, sin permisos ni zohoGuard (cualquier usuario autenticado lo ve).
      { path: 'mi-perfil', loadChildren: () => import('./features/my-profile/my-profile.module').then(m => m.MyProfileModule) },
      // Campañas Masivas ahora vive bajo /settings (con menú lateral). Redirige la ruta vieja.
      { path: 'campaigns', redirectTo: 'settings/campaigns', pathMatch: 'full' },
      { path: 'campaigns/:id', redirectTo: 'settings/campaigns/:id' },
      { path: 'reports', canActivate: [zohoGuard, permissionGuard('reports.view')], loadChildren: () => import('./features/reports/reports.module').then(m => m.ReportsModule) },
      { path: 'audit', canActivate: [permissionGuard('audit.view')], loadChildren: () => import('./features/audit/audit.module').then(m => m.AuditModule) },
      { path: 'calls', canActivate: [zohoGuard, permissionGuard('calls.view')], loadChildren: () => import('./features/calls/calls.module').then(m => m.CallsModule) },
      // Entrada desde Zoho: el botón de allá abre /llamar?tel=... y aquí se
      // traduce el teléfono a su chat. Sin permiso de 'calls.view' a propósito:
      // ver el registro de llamadas y poder llamar a un cliente son cosas
      // distintas, y quien atiende necesita lo segundo.
      {
        path: 'llamar',
        canActivate: [zohoGuard],
        loadComponent: () => import('./features/calls/llamar-desde-zoho/llamar-desde-zoho.component')
          .then(m => m.LlamarDesdeZohoComponent),
      },
      // Campañas de Seguimiento ahora vive bajo /settings. Redirige la ruta vieja.
      { path: 'followups', redirectTo: 'settings/followups', pathMatch: 'full' },
      { path: '', redirectTo: 'inbox', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
